/* eslint-disable */
import { IProduct } from '@/components/Products/ProductsInfo';

export const RemoveSpaces = (str: string) =>
  str
    .replaceAll(' ', '-')
    .replaceAll('&', 'and')
    .replaceAll(',', '')
    .replaceAll(':', '')
    .replaceAll('?', '')
    .toLowerCase();

export const convertToNormal = (str?: string) =>
  str
    ?.replaceAll('-', ' ')
    .replaceAll(' and ', ' & ')
    .replaceAll('/', ' ')
    .replace(/(?:^|\s)(\S)/gu, (m) => m.toUpperCase())
    .replaceAll(' Or ', ' or ');
